"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePropertyFromFeature = void 0;
var lodash_1 = require("lodash");
var makePropertyFromFeature = function (feature) {
    var _a = __read(feature.geometry.coordinates, 2), longitude = _a[0], latitude = _a[1];
    return __assign(__assign({}, (0, lodash_1.pick)(feature.properties, ["address", "city", "state", "zipcode"])), { id: feature.properties.propertyId, point: { longitude: longitude, latitude: latitude }, parcel: null });
};
exports.makePropertyFromFeature = makePropertyFromFeature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL01hcHMvTGF5ZXJlZE1hcC91dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxpQ0FBOEI7QUFHdkIsSUFBTSx1QkFBdUIsR0FBRyxVQUFDLE9BQVk7SUFDNUMsSUFBQSxLQUFBLE9BQXdCLE9BQU8sQ0FBQyxRQUFRLENBQUMsV0FBVyxJQUFBLEVBQW5ELFNBQVMsUUFBQSxFQUFFLFFBQVEsUUFBZ0MsQ0FBQztJQUMzRCw2QkFDSyxJQUFBLGFBQUksRUFBQyxPQUFPLENBQUMsVUFBVSxFQUFFLENBQUMsU0FBUyxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsU0FBUyxDQUFDLENBQUMsS0FDcEUsRUFBRSxFQUFFLE9BQU8sQ0FBQyxVQUFVLENBQUMsVUFBVSxFQUNqQyxLQUFLLEVBQUUsRUFBRSxTQUFTLFdBQUEsRUFBRSxRQUFRLFVBQUEsRUFBRSxFQUM5QixNQUFNLEVBQUUsSUFBSSxJQUNaO0FBQ0osQ0FBQyxDQUFDO0FBUlcsUUFBQSx1QkFBdUIsMkJBUWxDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgcGljayB9IGZyb20gXCJsb2Rhc2hcIjtcbmltcG9ydCB7IFByb3BlcnR5IH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IG1ha2VQcm9wZXJ0eUZyb21GZWF0dXJlID0gKGZlYXR1cmU6IGFueSk6IFByb3BlcnR5ID0+IHtcbiAgY29uc3QgW2xvbmdpdHVkZSwgbGF0aXR1ZGVdID0gZmVhdHVyZS5nZW9tZXRyeS5jb29yZGluYXRlcztcbiAgcmV0dXJuIHtcbiAgICAuLi5waWNrKGZlYXR1cmUucHJvcGVydGllcywgW1wiYWRkcmVzc1wiLCBcImNpdHlcIiwgXCJzdGF0ZVwiLCBcInppcGNvZGVcIl0pLFxuICAgIGlkOiBmZWF0dXJlLnByb3BlcnRpZXMucHJvcGVydHlJZCxcbiAgICBwb2ludDogeyBsb25naXR1ZGUsIGxhdGl0dWRlIH0sXG4gICAgcGFyY2VsOiBudWxsLFxuICB9O1xufTtcbiJdfQ==